<template>
<div>
<ContentHeader title="Soru Listesi Hesaplaması"  url="QuestionlistSameTypeCalculations" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<div class="mt-4">

<span class="p-float-label mb-5 mt-0" >
  <InputText id="calculation_name" type="text" v-model="item.name" class="w-full p-inputtext-sm" :class="{'p-invalid':has_error }" @input="removeError"  />
  <label for="calculation_name"  :class="{'hidden':has_error }">İsim</label>
  <small id="calculation_name-help" class="p-error pt-2" v-if="has_error"> İsim gerekli</small>
</span>


<div class="p-float-label mb-5 mt-0">
    <Dropdown v-model="item.customattribute_id" inputId="dd-city" :options="customattributes" filter optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" />
    <label for="dd-city">İlişkili Özel Nitelik</label>
</div>



<QuestionlistCalculationRoot 
:nodesdata="item.calculation" 
:questionlistoptions="questionlistoptions" 
:inputfieldclasses="inputfieldclasses"
:inputfields="inputfields"
:inputfieldsections="inputfieldsections"
:customattributes="customattributes"
:customcalculations="customcalculations"
></QuestionlistCalculationRoot>



</div>

<div class="flex align-items-center justify-content-end mb-6 mt-4">

<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="submit" @click="submit"></Button>
</div>

</div>	
</template>

<script>
export default {

  name: 'QuestionlistSameTypeCalculation',

  data () {
    return {
      loading:true,
      item:{
        id:null,
        name:null,
        calculation:null,
        customattribute_id:null,
      },
      booleanoptions:[
      {name:"Açık",id:1},
      {name:"Kapalı",id:0},
      ],
      lowerlimit:0,
      upperlimit:0,
      questionlistoptions:[],
      inputfieldclasses:[],
      inputfields:[],
      inputfieldsections:[],
      customattributes:[],
      customcalculations:[],
      has_error:false,
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    removeError()
    {
      this.has_error = false
    },
    async getData()
    {
      this.loading = await true
      if(this.$store.state.questionlists.questionlist)
      {
        if(this.$store.state.questionlists.questionlist.type=="various_questions")
        {
          this.inputfields =  await this.generalApiGetWithoutLoader("questionlists/active_inputfields/"+this.$store.state.questionlists.questionlist.id)
          this.inputfields.unshift({id:"all",name:"Bütün Sorular"})

          this.inputfieldsections =  await this.generalApiGetWithoutLoader("questionlists/active_inputfieldsections/"+this.$store.state.questionlists.questionlist.id)
          this.inputfieldsections.unshift({id:"all",name:"Bütün Bölüm Soruları"})
        }
        if(this.$store.state.questionlists.questionlist.type=="same_question_pattern")
        {
          this.questionlistoptions =  await this.generalApiGetWithoutLoader("questionlistoptions/"+this.$store.state.questionlists.questionlist.id)
          this.questionlistoptions.unshift({id:"all",name:"Bütün Seçenekler"})
        }
      }
      
      this.inputfieldclasses =  await this.generalApiGetWithoutLoader("inputfieldclasses/"+this.$store.state.questionlists.questionlist.id)
      this.customattributes =  await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.questionlists.questionlist.brand_id)
      
      this.customcalculations = await this.generalApiGetWithoutLoader("questionlistsametypecalculations/"+this.$route.params.id)

      if(this.$route.params.calculation_id)
      {
        this.customcalculations = await this.customcalculations.filter(item=>item.id !== parseInt(this.$route.params.calculation_id))
      }
      

      

      await this.$store.dispatch('calculations/setCustomAttributes',this.customattributes)
      let no_class = await [{name:"Bütün Sınıflar",id:"all"}]
      this.inputfieldclasses = await no_class.concat(this.inputfieldclasses)

      
     
      if(this.$route.params.calculation_id)
      {
        this.item = await this.generalApiGetWithoutLoader("questionlistsametypecalculation/"+this.$route.params.calculation_id)  
        console.log("item")      
        console.log(this.item)
      }
      
      this.loading = await false
    },
    submit()
    {

      console.log(this.$store.state.calculations.nodes)
      console.log(this.$store.state.calculations.connections)

      
      if(!this.item.name || this.item.name=="")
      {
        this.has_error = true
        return false
      }

      
      //return false
        let formdata = new FormData()
        formdata.append('questionlist_id', this.$store.state.questionlists.questionlist.id);
        formdata.append('name', this.item.name);
        formdata.append('customattribute_id', this.item.customattribute_id);
        let nodes = this.$store.state.calculations.nodes
        let connections = this.$store.state.calculations.connections
        let calculation = {nodes:nodes,connections:connections}
        formdata.append("calculation",JSON.stringify(calculation)) 
        if(this.$route.params.calculation_id)
        {
          console.log("update")
          this.generalSubmission(formdata,"questionlistsametypecalculation/"+this.$route.params.calculation_id,this.afterSubmit)
        }
        else
        {
          this.generalSubmission(formdata,"questionlistsametypecalculation",this.afterSubmit)
        }
        
    },
    afterSubmit(response)
    {
        console.log(response.data);
        if(!this.$route.params.calculation_id)
        {
          this.$router.push({ name: 'QuestionlistSameTypeCalculations' })
        }
        
       
          
    },
  }
}
</script>

<style lang="css" scoped>
</style>